import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: () => { return '/catering' }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/AuthPage.vue'),
    meta: { public: true }
  },
  {
    path: '/preauth',
    name: 'PreauthPasswordSetup',
    component: () => import('@/views/PreauthPasswordSetup.vue'),
    meta: { public: true }
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('../views/EmptyPage.vue')
  },

  {
    path: '/catering',
    name: 'Catering',
    component: () => import('../views/CateringHome.vue')
  },
  {
    path: '/catering/resources',
    name: 'Resources',
    component: () => import('../views/ResourcesPage.vue')
  },
  {
    path: '/catering/personnel',
    name: 'Personnel',
    component: () => import('../views/PersonnelPage.vue')
  },
  {
    path: '/catering/clients',
    name: 'Clients',
    component: () => import('../views/ClientsPage.vue')
  },
  {
    path: '/catering/articles',
    name: 'Articles',
    component: () => import('../views/ArticulsPage.vue')
  },
  {
    path: '/catering/dishes',
    name: 'Dishes',
    component: () => import('../views/DishesPage.vue')
  },
  {
    path: '/catering/mainConfig',
    name: 'MainConfig',
    redirect: () => { return '/catering/rights' }
  },
  {
    path: '/catering/rights',
    name: 'Rights',
    component: () => import('../views/subPages/RightsPage.vue')
  },
  {
    path: '/catering/orders',
    name: 'OrdersGlobal',
    component: () => import('../views/orders/OrdersIndex.vue')
  },

  {
    path: '/customers',
    name: 'Customers',
    component: () => import('../views/CustomersHome.vue')
  },
  {
    path: '/customers/fClients',
    name: 'FClients',
    component: () => import('../views/FClientsPage.vue')
  },
  {
    path: '/customers/menu',
    name: 'Menu',
    component: () => import('../views/MenuPage.vue')
  },
  {
    path: '/customers/orders',
    name: 'OrdersScoped',
    component: () => import('../views/orders/OrdersIndex.vue')
  },
  {
    path: '/customers/lunches',
    name: 'Lunches',
    component: () => import('../views/subPages/LunchesPage.vue')
  },

  {
    path: '/revision',
    name: 'Revision',
    component: () => import('../views/RevisionPage.vue')
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/ReportPage.vue')
  },

  {
    path: '/catering/payForms',
    name: 'PayForms',
    component: () => import('../views/subPages/PayFormsPage.vue')
  },
  {
    path: '/catering/categories',
    name: 'Categories',
    component: () => import('../views/subPages/CategoriesPage.vue')
  },
  {
    path: '/catering/roles',
    name: 'Roles',
    component: () => import('../views/subPages/RolesPage.vue')
  },
  {
    path: '/catering/units',
    name: 'Units',
    component: () => import('../views/subPages/UnitsPage.vue')
  },
  {
    path: '/catering/foodClaims',
    name: 'FoodClaims',
    component: () => import('../views/subPages/FoodClaimsPage.vue')
  },
  {
    path: '/catering/complexTypes',
    name: 'ComplexTypes',
    component: () => import('../views/subPages/ComplexTypesPage.vue')
  },
  {
    path: '/customers/terminals',
    name: 'Terminals',
    component: () => import('../views/subPages/TerminalsPage.vue')
  },
  {
    path: '/customers/marmites',
    name: 'Marmites',
    component: () => import('../views/subPages/MarmitesPage.vue')
  },
  {
    path: '/customers/finModel',
    name: 'FinModel',
    component: () => import('../views/subPages/FinModelPage.vue')
  },


  { path: '/mainConfig', redirect: (to) => ({ path: '/catering/rights', query: to.query }) },
  { path: '/resources',  redirect: (to) => ({ path: '/catering/resources', query: to.query }) },
  { path: '/personnel',  redirect: (to) => ({ path: '/catering/personnel', query: to.query }) },
  { path: '/clients',    redirect: (to) => ({ path: '/catering/clients', query: to.query }) },
  { path: '/articles',   redirect: (to) => ({ path: '/catering/articles', query: to.query }) },
  { path: '/dishes',     redirect: (to) => ({ path: '/catering/dishes', query: to.query }) },
  { path: '/rights',     redirect: (to) => ({ path: '/catering/rights', query: to.query }) },
  { path: '/fClients',   redirect: (to) => ({ path: '/customers/fClients', query: to.query }) },
  { path: '/menu',       redirect: (to) => ({ path: '/customers/menu', query: to.query }) },
  { path: '/lunches',    redirect: (to) => ({ path: '/customers/lunches', query: to.query }) },
  { path: '/finModel',   redirect: (to) => ({ path: '/customers/finModel', query: to.query }) },
  {
    path: '/orders',
    redirect: (to) => (to.query && to.query.id
      ? { path: '/customers/orders', query: to.query }
      : { path: '/catering/orders', query: to.query })
  },
  { path: '/payForms',     redirect: (to) => ({ path: '/catering/payForms', query: to.query }) },
  { path: '/categories',   redirect: (to) => ({ path: '/catering/categories', query: to.query }) },
  { path: '/roles',        redirect: (to) => ({ path: '/catering/roles', query: to.query }) },
  { path: '/units',        redirect: (to) => ({ path: '/catering/units', query: to.query }) },
  { path: '/foodClaims',   redirect: (to) => ({ path: '/catering/foodClaims', query: to.query }) },
  { path: '/complexTypes', redirect: (to) => ({ path: '/catering/complexTypes', query: to.query }) },
  { path: '/customers/complexTypes', redirect: (to) => ({ path: '/catering/complexTypes', query: to.query }) },
  { path: '/terminals',    redirect: (to) => ({ path: '/customers/terminals', query: to.query }) },
  { path: '/marmites',     redirect: (to) => ({ path: '/customers/marmites', query: to.query }) },

  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore()

  const isPublic = to.meta?.public === true
  const isRoot = to.path === '/'

  if (!isPublic && !auth.user && auth.loading === false) {
    await auth.checkSession()
  }

  const isAuth = auth.isAuthenticated

  if (isRoot) {
    return next({ path: isAuth ? '/catering' : '/auth' })
  }

  if (!isPublic && !isAuth) {
    return next({ path: '/auth' })
  }

  if (to.path === '/auth' && isAuth) {
    return next({ path: '/catering' })
  }

  next()
})

export default router
